import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { StylesProvider, ThemeProvider } from '@material-ui/core';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'styles/index.css';

import App from 'components/App/App';
import Modal from 'components/Modal/Modal';
import Snackbar from 'components/Snackbar/Snackbar';
import { AuthProvider } from 'context/AuthProvider/AuthProvider';
import { DateProvider } from 'context/DateProvider/DateProvider';
import { FilterProvider } from 'context/FilterProvider/FilterProvider';
import { ModalProvider } from 'context/ModalProvider/ModalProvider';
import { SearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import SnackbarProvider from 'context/SnackbarProvider/SnackbarProvider';
import { makeServer } from 'mocks/server/server';
import styles from 'styles';
import { msalConfig } from 'utils/auth/authConfig';
import { USE_MOCK_SERVER } from 'utils/environmentVariables';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

if (USE_MOCK_SERVER === 'true') {
  makeServer();
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <BrowserRouter>
        <StylesProvider jss={styles.plugins}>
          <ThemeProvider theme={styles.theme}>
            <SearchParamsProvider>
              <SnackbarProvider>
                <FilterProvider>
                  <DateProvider>
                    <ModalProvider>
                      <App />
                      <Snackbar />
                      <Modal />
                    </ModalProvider>
                  </DateProvider>
                </FilterProvider>
              </SnackbarProvider>
            </SearchParamsProvider>
          </ThemeProvider>
        </StylesProvider>
      </BrowserRouter>
    </AuthProvider>
  </MsalProvider>
);
